import { useState } from 'react';
import { UsersChats } from "../../assets/CommonSvg";
import {
    Dialog,
    DialogContent,
} from '@mui/material';
import InboxChat from './Inbox';
import HeaderChat from './Header';
import ChatBody from './ChatBody';
import NewChatGroup from './NewGroup';
import { useDispatch, useSelector } from 'react-redux';
import { changeChatView, changeSelectedRoom, selectChatView, selectSelectedRoom } from '../../slices/chat';



const ChatModule = ({ preOpen, setOpenChat, disableAdd }) => {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const chatView = useSelector(selectChatView)
    const selectedRoom = useSelector(selectSelectedRoom)

    const setChatView = async (view) => {
        await dispatch(changeChatView(view))
    }

    const setSelectedRoom = async (chatRoom) => {
        await dispatch(changeSelectedRoom(chatRoom))
    }


    const handleClickOpen = () => {
        setChatView("inbox")
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        if (setOpenChat) {
            setOpenChat(false)
        }
    };

    return (
        <>
            {/* Floating Chat Button */}
            <div className="fixed right-6 bottom-16 z-50">
                <button
                    onClick={handleClickOpen}
                    className="flex items-center justify-center w-14 h-14 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-colors"
                >
                    <UsersChats />
                </button>
            </div>

            {/* Chat Dialog */}
            <Dialog
                open={open || preOpen}
                onClose={handleClose}
                classes={{
                    container: "flex items-end justify-end",
                    paper: "m-4 w-[350px] h-[500px] max-h-[80vh] rounded-2xl shadow-xl"
                }}
                BackdropProps={{ style: { backgroundColor: 'transparent' } }}
            >
                <DialogContent className="p-0 h-full border flex flex-col">
                    {/* Chat header */}
                    <div className='pl-3 pr-3 pt-3'>
                        <HeaderChat
                            handleClose={handleClose}
                            chatView={chatView}
                            setChatView={setChatView}
                            selectedRoom={selectedRoom}
                        />
                    </div>
                    {chatView == "inbox"
                        ? <InboxChat
                            disableAdd={disableAdd}
                            setChatView={setChatView}
                            setSelectedRoom={setSelectedRoom}
                        />
                        : chatView == "chat"
                            ? <ChatBody
                                selectedRoom={selectedRoom}
                            />
                            : chatView == "group"
                                ? <NewChatGroup
                                    setChatView={setChatView}
                                    setSelectedRoom={setSelectedRoom} />
                                : ""
                    }
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ChatModule;